import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export type InternalOrganizationMasterServiceAgreementResponseType = {
  agreement_html: string;
  date_version: string;
  id: string;
};

export const getInternalOrganizationMasterServiceAgreementApi = (): Promise<
  ApiResponseType<InternalOrganizationMasterServiceAgreementResponseType>
> => {
  const uri = '/organization/internal/master-service-agreement/';

  return authApiService.GET(uri);
};
